import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { UserService } from 'app/shared/services/user.service';
import { GUIDHelpers } from 'app/shared/utilities/developHelpers';
import { ColorList } from 'app/bars/topbar/topbarData';

@Component({
  selector: 'custom-datalist',
  templateUrl: './custom-datalist.component.html',
  styleUrls: ['./custom-datalist.component.css']
})
export class CustomDatalistComponent implements OnChanges {

  @Input() options: DatalistOptions;
  @Output() selectedItem: EventEmitter<any> = new EventEmitter<any>();
  ghelp = new GUIDHelpers();
  uniqueId: string = this.ghelp.newGUID();
  shownData: any;
  shownDataIsArray: boolean = false;
  shownValueArray: string[] | null = null;

  constructor(private user: UserService) { }

  ngOnChanges(): void {
    this.filterResult();
  }

  filterResult() {
    this.options.itemChosen = false;
    if (Array.isArray(this.options.shownValue)) {
      this.shownDataIsArray = true;
      this.shownValueArray = (this.options.shownValue as string[]).map(value => value.trim()).filter(value => value !== '-' && value !== '');
    }

    this.shownData = !!this.options.searchValue && this.options.searchValue.length > 0 ? this.options.dataList.filter(item => {
      if (Array.isArray(this.options.shownValue)) {
        // If shownValue is an array, check if any of the item's values match the searchValue
        return this.shownValueArray.some(shownValue => {
          return shownValue && item[shownValue] &&
            item[shownValue].toLowerCase().includes(this.options.searchValue.toLowerCase());
        });
      } else if (typeof this.options.shownValue === 'string') {
        // If shownValue is a string, filter based on that single property
        return item[this.options.shownValue].toLowerCase().includes(this.options.searchValue.toLowerCase());
      }
      return false; // Handle other cases as needed
    })?.sort((a: any, b: any) => a[this.options.shownValue.toString()]?.toLowerCase() < b[this.options.shownValue.toString()]?.toLowerCase() ? -1 : 1) : 
    this.options.dataList?.sort((a: any, b: any) => a[this.options.shownValue.toString()]?.toLowerCase() < b[this.options.shownValue.toString()]?.toLowerCase() ? -1 : 1);
    //this.shownData = !!this.options.searchValue && this.options.searchValue.length > 0 ? this.options.dataList.filter(x => x[this.options.shownValue].toLowerCase().match(this.options.searchValue.toLowerCase())) : this.options.dataList;
  }

  itemSelected(value: string) {
    this.selectedItem.emit(value[this.options.dataValue]);
    this.options.itemChosen = true;
  }

  findBadgeColor(type: string, item: any) {
    if (type == 'b') {
      return !!item.backgroundColor ? item.backgroundColor : '#6c757d';
    } else {
      return !!item.textColor ? item.textColor : '#ffffff';
    }
  }

  findColor(type: string, name: string) {
    if (!!type && !!name) {
      let init = name.trim().substring(0, 1).toUpperCase();
      if (name != '') {
        if (!name) return;
        init = name.replace(/[^a-zA-Z]/g, '').substring(0, 1).toUpperCase();
        switch (type) {
          case 'b':
            if (!!init) {
              return ColorList.colors[init].background;
            } else {
              return '#80b8f2';
            }
          case 'c':
            if (!!init) {
              return ColorList.colors[init].color;
            } else {
              return 'white';
            }
          default:
            if (!!init) {
              return init;
            } else {
              return '';
            }
        }
      }
      return;
    }
  }

}

class DatalistOptions {
  dataList: any;
  shownValue: string | [];
  icon: boolean = false;
  dataValue: string;
  itemChosen: boolean = false;
  searchValue: string;
  showOnHighlight: boolean = true;
  badge: boolean = false;
}